var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import classNames from "classnames";
import TabButton from "./TabButton";
// styles
import "./tab.scss";
// use the optional prop interface to define the default props
const defaultProps = {
    "data-testid": "tecma-tab",
    type: "outlined",
    disabled: false,
};
/**
 * Tabbed interfaces are a way of navigating between multiple panels, reducing clutter and fitting more into a smaller space.
 */
const Tab = (_a) => {
    var { items, type, disabled, className } = _a, rest = __rest(_a, ["items", "type", "disabled", "className"]);
    const classList = classNames("tecma-tab", { [`${type}`]: type }, className);
    const [activeTab, setActiveTab] = useState(0);
    const handleTabButtonClick = (index) => {
        setActiveTab(index);
    };
    return (_jsxs("div", Object.assign({ className: classList }, rest, { children: [_jsx("nav", { children: _jsx("ul", { children: items.length > 0 &&
                        items.map((item, index) => (_jsx(TabButton, { label: item.title, iconName: item.iconName, isActive: index === activeTab, onClick: () => handleTabButtonClick(index), disabled: disabled }, item.title))) }) }), _jsx("section", { children: _jsx("div", { children: items[activeTab].content }) })] })));
};
Tab.defaultProps = defaultProps;
const TabSpace = Object.assign(Tab, {
    Button: TabButton,
});
export { TabSpace as Tab };
